import './App.css';
import Minter from './Minter'
import Navbarr from './Pages/Navbarr/Navv';


function App() {
  return (
    <div className="App">
      {/* <Minter></Minter> */}
      <Navbarr/>

    
    </div>
  );
}

export default App;



